import uuid from 'node-uuid';
import { getSettlementDateForSubmissionDate } from '../calendar/selectors';
import { fetchCalendar } from '../calendar/actions';
import { goBackPage } from '../page/actions';
import { calendarTypes } from '../../config';
import { getPayeeById } from '../commonSelectors/selectors';
import { getPayments } from './selectors';

export const BACS_ADD_PAYMENT = 'BACS/ADD_PAYMENT';
export const BACS_ADD_MULTIPLE_PAYMENTS = 'BACS/ADD_MULTIPLE_PAYMENTS';
export const BACS_UPDATE_TO_ACCOUNT = 'BACS/UPDATE_TO_ACCOUNT';
export const BACS_UPDATE_FROM_ACCOUNT = 'BACS/UPDATE_FROM_ACCOUNT';
export const BACS_UPDATE_SUBMISSION_DATE = 'BACS/UPDATE_DATE';
export const BACS_UPDATE_REFERENCE = 'BACS/UPDATE_REFERENCE';
export const BACS_REMOVE_PAYMENT = 'BACS/REMOVE_PAYMENT';
export const BACS_UPDATE_AMOUNT = 'BACS/UPDATE_AMOUNT';
export const BACS_COPY_REF_TO_ALL = 'BACS/COPY_REF_TO_ALL';
export const BACS_UPDATE_BACS_ID = 'BACS/UPDATE_BACS_ID';
export const BACS_UPDATE_PAYMENT_NAME = 'BACS/UPDATE_PAYMENT_NAME';
export const BACS_UPDATE_HMRC_REF = 'BACS/UPDATE_HMRC_REF';
export const INITIALISE_BACS_CREDIT = 'INITIALISE_BACS_CREDIT';
export const BACS_UPDATE_PAYMENT_ID = 'BACS_UPDATE_PAYMENT_ID';
export const SET_BACS_AUTHORISER_ID = 'SET_BACS_AUTHORISER_ID';
export const BACS_CREDIT_SET_AUTHORISERS = 'BACS/SET_AUTHORISERS';
export const BACS_UPDATE_IMPORTED_PAYMENTS = 'BACS/UPDATE_IMPORTED_PAYMENTS';

export const copyRefToAll = (paymentsToInternalCreditCards) => ({
	type: BACS_COPY_REF_TO_ALL,
	paymentsToInternalCreditCards,
});

export const initialiseBacsCredit = (bacsDetails, payments) => ({
	type: INITIALISE_BACS_CREDIT,
	payments: payments.map((payment) => ({ ...payment, id: uuid.v1() })),
	bacsDetails: {
		...bacsDetails,
		context_id: bacsDetails.id,
		id: uuid.v1(),
	},
});

export const addPayment = (payment) => ({
	payment,
	type: BACS_ADD_PAYMENT,
});

export const addMultiplePayments = (payments) => ({
	type: BACS_ADD_MULTIPLE_PAYMENTS,
	payments,
});
export const updateToAccount = ({ id, accountId }) => ({
	type: BACS_UPDATE_TO_ACCOUNT,
	id,
	accountId,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const updateFromAccount = ({ accountId }) => {
	return {
		type: BACS_UPDATE_FROM_ACCOUNT,
		accountId,
		meta: {
			allowedDuringApiCall: true,
		},
	};
};

export const updateSubmissionDate =
	({ submissionDate }) =>
	(dispatch, getState) => {
		const state = getState();
		const settlementDate = getSettlementDateForSubmissionDate(state, submissionDate);

		return dispatch({
			type: BACS_UPDATE_SUBMISSION_DATE,
			submissionDate,
			settlementDate,
		});
	};

export const goBackAfterDeadlineMissed = (submissionDate) => (dispatch) => {
	dispatch(updateSubmissionDate({ submissionDate }));
	return dispatch(fetchCalendar(calendarTypes.CALENDAR_TYPE_BACS)).then(() => dispatch(goBackPage()));
};

export const updateReference = ({ id, reference }) => ({
	type: BACS_UPDATE_REFERENCE,
	id,
	reference,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const removePayment = ({ id }) => ({
	type: BACS_REMOVE_PAYMENT,
	id,
});

export const updateAmount = ({ id, amount }) => ({
	type: BACS_UPDATE_AMOUNT,
	id,
	amount,
});

export const updateBacsId = ({ bacsId }) => ({
	type: BACS_UPDATE_BACS_ID,
	bacsId,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const updatePaymentName = ({ paymentName }) => ({
	type: BACS_UPDATE_PAYMENT_NAME,
	paymentName,
});

export const updateHmrcRef = ({ id, hmrcReference }) => ({
	type: BACS_UPDATE_HMRC_REF,
	hmrcReference,
	id,
});
export const updateBacsCreditPayment =
	({ id, accountId, reference }) =>
	(dispatch) => {
		dispatch(updateToAccount({ id, accountId }));
		return dispatch(updateReference({ id, reference }));
	};

export const setBacsCreditAuthorisers = (authorisers) => ({
	type: BACS_CREDIT_SET_AUTHORISERS,
	authorisers,
});

export const updateBacsImportedPayments = (importedPaymentsList) => ({
	type: BACS_UPDATE_IMPORTED_PAYMENTS,
	payload: importedPaymentsList,
});

export const postAddPayeeUpdateBacsPayment = (payment, response, isEdit) => (dispatch, getState) => {
	const state = getState();
	const { reference } = getPayeeById(state, payment?.toAccount);
	const { id, name, sort_code, account_number } = response;
	const [firstPayment = {}] = getPayments(state);
	const oldPayee = getPayeeById(state, firstPayment.toAccount);
	const shouldUpdate =
		oldPayee.to_account &&
		oldPayee.to_account?.name === name &&
		oldPayee.to_account?.sort_code === sort_code &&
		oldPayee.to_account?.account_number === account_number;
	if (isEdit || shouldUpdate) {
		return dispatch({
			type: INITIALISE_BACS_CREDIT,
			/**
			 * @todo rename `payments` -> `payload` to comply with FSA best practices.
			 */
			payments: [
				{
					...payment,
					reference,
					id,
					hmrcReference: firstPayment.hmrcReference,
					approverId: firstPayment.approverId,
					initialReference: firstPayment.initialReference,
					amount: firstPayment.amount,
				},
			],
		});
	}

	const { amount: _amount, ...restOfPayment } = payment;
	return dispatch({
		type: BACS_ADD_PAYMENT,
		/**
		 * @todo rename `payment` -> `payload` to comply with FSA best practices.
		 */
		payment: {
			...restOfPayment,
			reference,
			id,
		},
	});
};
